import { IJobCardsResponse } from '~/types/response/jobCard';
import { IJobCardReport } from '~/types/models/jobCardReport';
import { IPagination } from '~/store/jobCard';
import axiosBase from '~/utils/axios';
import { IJobItem } from '~/types/models/jobItem';

export default class JobCardsApi {
  public static async loadJobCards(filter: Record<string, any>, pagination: IPagination): Promise<IJobCardsResponse> {
    return axiosBase
      .get('/jobCards', {
        params: {
          filter,
          pagination,
        },
      })
      .then(({ data }) => data);
  }

  public static async updateJobCardReport(
    id: string,
    data: Partial<IJobCardReport>,
  ): Promise<{ id: string; data: Partial<IJobCardReport> }> {
    // return axiosBase.get('/');
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ id, data: { isRun: data.isRun } });
      }, 500);
    });
  }

  public static async getJobItems(jobCardId: string | number): Promise<IJobItem[]> {
    const { data } = await axiosBase.get(`/jobCards/${jobCardId}/items`);
    return data;
  }
}
